/**
 * reflects BiqQueryJobConfigurationDto dto on server
 */
import {Dto} from 'common';

export class ProtocolFindProductionLogsBodyDto extends Dto {
    startDate: number;
    endDate: number;
    messageQuery: string;
    email: string;

    public deserialize(input: any): this {
        Object.assign(this, input);
        return this;
    }
}
